import React, { useState } from "react";
import PublicPricing from "@/pages/Pricing";
import { Button } from "@/components/ui/button";
import { CreditCard } from "lucide-react";
import UpgradePlanDialog from "@/components/UpgradePlanDialog";

export default function Pricing() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="px-4 pt-4">
        <div
          className="panel-hero rounded-2xl p-5 flex items-center justify-between gap-4 flex-wrap"
          data-testid="self-serve-upgrade-panel"
        >
          <div>
            <div className="text-[10px] font-mono uppercase tracking-widest text-cyan-300">§ Self-serve upgrade</div>
            <div className="font-display font-black text-xl mt-1">Convert your trial → paid, instantly.</div>
            <div className="text-sm text-muted-foreground mt-1 max-w-lg">
              Pick a Starter, Pro, or Enterprise subscription and check out through Stripe. Tax handling included.
            </div>
          </div>
          <Button
            onClick={() => setOpen(true)}
            data-testid="open-upgrade-dialog-btn"
            className="tenant-btn rounded-full h-11 px-5 font-display font-bold text-sm"
          >
            <CreditCard className="w-4 h-4 mr-2" /> See plans &amp; upgrade
          </Button>
        </div>
      </div>
      <PublicPricing variant="console" />
      <UpgradePlanDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
}
